module.exports = __webpack_public_path__ + "media/dog.6d169f19.mp3";